<div #pad class="pricing-pad">

  <!-- Review Changes Template -->
  <ng-template #reviewChangesBtn>

    <ng-container [ngSwitch]="this.getChangesState()">
      <ng-container *ngSwitchCase="'Review'">
        <ng-container *ngTemplateOutlet="reviewChanges"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'Merge'">
        <ng-container *ngTemplateOutlet="mergeChanges"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'Colors & Labels'">
        <ng-container *ngTemplateOutlet="colorsAndLabels"></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #reviewChanges>
      <dx-button (onClick)="this.onReviewChangesClicked()"
                 [disabled]="!this.canReviewChanges()"
                 text="Review Changes"
                 type="default"
                 width="100%"
      ></dx-button>
    </ng-template>

    <ng-template #mergeChanges>
      <dx-button (onClick)="this.onSyncPositionsClicked()"
                 [disabled]="this.isMergeDialogVisible || !this.canSyncPositions()"
                 text="Sync Positions"
                 type="default"
                 width="100%"
      ></dx-button>
    </ng-template>

    <ng-template #colorsAndLabels>
      <dx-button (onClick)="this.onSyncColorAndLabelsClicked()"
                 [disabled]="!this.canSyncLabelsAndColors()"
                 text="Sync Positions"
                 type="default"
                 width="100%"
      ></dx-button>
    </ng-template>
  </ng-template>

  <!--  Full Version -->
  <div [style.display]="this.isShortVersion ? 'none' : 'block'" [style.height.%]="100">
    <div class="legs">

      <div [style.display]="this.expandConfigurator ? 'none' : 'block'" class="header">
        <ng-container *ngTemplateOutlet="grandTotalsTpl; context: {inline: true}"></ng-container>
      </div>

      <div [style.display]="this.expandConfigurator ? 'none' : 'block'" class="section symbol-n-strategy">

        <div class="body">

          <div class="block symbol">
            <ets-symbol-picker
              [disabled]="!this.tradingInstrument"
              [selectedInstrument]="this.tradingInstrument"
              (instrumentSelected)="this.onSymbolPickerInstrumentSelected($event)"
            ></ets-symbol-picker>
          </div>

          <div class="block strategy">
            <div class="label">Strategy</div>
            <dx-select-box
              (onValueChanged)="this.onStrategyChanged()"
              [(value)]="this.selectedStrategy"
              [disabled]="!this.tradingInstrument || this.isMergeMode"
              [items]="this.strategyList"
              placeholder="Strategy"
            ></dx-select-box>
          </div>

          <div class="block option-type">
            <div class="label">Option Type</div>
            <dx-select-box
              (onValueChanged)="this.onOptionTypeChanged()"
              [(value)]="this.selectedOptionType"
              [disabled]="!this.selectedStrategy || this.isMergeMode"
              [items]="this.optionTypeList"
              placeholder="Option"
            ></dx-select-box>
          </div>

          <div class="block strike-width">
            <div class="label">
              Strikes Width
            </div>
            <dx-number-box
              (onValueChanged)="this.onStrikeWidthChanged()"
              [(value)]="this.strikeWidth"
              [disabled]="!this.selectedStrategy || this.isMergeMode"
              [showClearButton]="true"
              [showSpinButtons]="true"
              [step]="this.strikeLadderStep"
              [min]="this.strikeLadderStep"
            ></dx-number-box>
          </div>

          <div class="block expiration">
            <div class="label">Expiration</div>

            <ets-expiration-selector
              [(selectedExpiration)]="this.selectedExpiration"
              [disabled]="!this.selectedStrategy || this.isMergeMode"
              [expirationDescriptors]="this.expirationList"
              [showClearButton]="true"
            ></ets-expiration-selector>

<!--            <dx-select-box-->
<!--              [(value)]="this.selectedExpiration"-->
<!--              [disabled]="!this.selectedStrategy || this.isMergeMode"-->
<!--              [items]="this.expirationList"-->
<!--              [showClearButton]="true"-->
<!--              displayExpr="dateWithDaysToExpiration"-->
<!--            >-->
<!--              <div *dxTemplate="let data of 'item'">-->
<!--                <span [style.color]="(data?.expirationTicker === '@SPX' ? 'yellow' : '')">-->
<!--                   {{ data?.dateWithDaysToExpiration }}-->
<!--                </span>-->
<!--              </div>-->
<!--            </dx-select-box>-->
          </div>

          <div class="block offset">
            <div class="label">
              <div (click)="this.changeOffsetMode('Offset')"
                   [class.disabled]="!this.selectedStrategy || this.isMergeMode"
                   [class.hot]="this.strikeOffsetMode === 'Offset'"
                   class="btn"
              >
                Offset
              </div>
              <div (click)="this.changeOffsetMode('Strike')"
                   [class.disabled]="!this.selectedStrategy || this.isMergeMode"
                   [class.hot]="this.strikeOffsetMode === 'Strike'"
                   class="btn"
              >
                Strike
              </div>
            </div>
            <div [style.display]="this.strikeOffsetMode === 'Offset' ? 'block' : 'none' ">
              <dx-number-box
                (onValueChanged)="this.onOffsetChanged()"
                [(value)]="this.strikeOffset"
                [disabled]="!this.selectedStrategy || this.isMergeMode"
                [inputAttr]="this.dxCenterTextStyleObj"
                [showClearButton]="true"
                [showSpinButtons]="true"
              ></dx-number-box>
            </div>
            <div [style.display]="this.strikeOffsetMode === 'Strike' ? 'block' : 'none' ">
              <ets-strikes-dropdown
                [(strike)]="this.baseStrike"
                [expiration]="this.selectedExpiration"
                [inputAttr]="this.dxCenterTextStyleObj"
                [targetInstrument]="this.tradingInstrument"
              >
              </ets-strikes-dropdown>
            </div>
          </div>

          <div class="block base-qty">
            <div class="label" style="text-align: center">
              Base Qty
            </div>
            <dx-number-box
              (onValueChanged)="this.onBaseQtyChanged()"
              [(value)]="this.baseQty"
              [disabled]="!this.selectedStrategy || this.isMergeMode"
              [min]="1"
              [showSpinButtons]="true"
              [inputAttr]="this.dxCenterTextStyleObj"
            ></dx-number-box>
          </div>

          <div class="block add">
            <dx-button (onClick)="this.onAddStrategyClicked()"
                       [disabled]="!this.canAddStrategy()"
                       text="Add"
                       type="normal"
            ></dx-button>
          </div>

        </div>

      </div>

      <hr [style.display]="this.expandConfigurator ? 'none' : 'block'" style="width: 50%; border-color: dimgray">

      <div class="controls">

        <div class="right side">
          <div class="legs-management">
            <dx-button (onClick)="this.onAddOptionClicked('Call')"
                       [disabled]="this.isMergeMode"
                       text="Add Call"
            ></dx-button>

            <dx-button (onClick)="this.onAddOptionClicked('Put')"
                       [disabled]="this.isMergeMode"
                       text="Add Put"
            ></dx-button>

            <dx-button (onClick)="this.onPasteComboClicked()"
                       [disabled]="!this.canPasteCombo()"
                       icon="paste"
                       text="Paste"
            ></dx-button>

            <dx-button (onClick)="this.onClearLegsClicked()"
                       [disabled]="this.isMergeMode"
                       text="Clear Legs"
            ></dx-button>

            <dx-button (onClick)="this.onReloadHedgesClicked()"
                       [disabled]="this.isMergeDialogVisible"
                       text="Re-load Hedges"
            ></dx-button>

          </div>

          <div class="legs-misc">

            <div class="disable-sorting">
              <dx-check-box
                (onValueChanged)="this.onAutoSortChanged()"
                [(value)]="this.autoSort"
                text="Auto-Sort"
              >
              </dx-check-box>
            </div>

            <div class="custom-sort">
              <dx-button (onClick)="this.showCustomSortDialog()" [disabled]="!this.canShowCustomSortDialog"
                         icon="sorted"
                         hint="Custom Sort"
              ></dx-button>
            </div>

            <div class="filter-expiration" [class.filtered]="!!this.filterExpiration">
              <dx-drop-down-button
                [hint]="'Set/Clear Expiration Filter'"
                [items]="this.filterExpirationList"
                [showArrowIcon]="false"
                [keyExpr]="'optionExpirationDate'"
                [displayExpr]="'dateWithDaysToExpiration'"
                icon="filter"
                [dropDownOptions]="{width: 120}"
                [splitButton]="true"
                (onItemClick)="this.onExpirationFilterChanged($event.itemData)"
                (onButtonClick)="this.onFilterButtonClick()"
              ></dx-drop-down-button>
            </div>

            <div class="pto">
              <dx-check-box
                [(value)]="this.priceToOpen"
                [disabled]="this.isMergeMode"
                text="Price To Open"
              ></dx-check-box>
            </div>

            <div class="underlying-filter" [class.filtered]="this.isUnderlyingFilterActive">
              <dx-select-box
                [items]="this.underlyingDropdownItems"
                [value]="this.underlyingDropdownValue"
                [readOnly]="this.isUnderlyingFilterReadOnly"
                (onValueChanged)="this.onUnderlyingFilterChanged($event)"
                [width]="110"
              ></dx-select-box>
            </div>

          </div>
        </div>

        <div class="left side">
          <div class="cb hide-strategy">
            <ng-container *ngIf="this.expandConfigurator">
              <i (click)="this.toggleExpandConfigurator()" class="fas fa-compress-arrows-alt expand-icon"></i>
              <span>Back To Normal Size</span>
            </ng-container>
            <ng-container *ngIf="!this.expandConfigurator">
              <i (click)="this.toggleExpandConfigurator()" class="fas fa-expand-arrows-alt expand-icon"></i>
              <span>Expand Full Size</span>
            </ng-container>
          </div>

          <div class="btn-review-changes">
            <ng-container *ngTemplateOutlet="reviewChangesBtn"></ng-container>
          </div>
        </div>
      </div>

      <br>

      <div class="scroll-area">
        <dx-scroll-view>
          <div class="scroll-data">
            <ng-container *ngIf="this.hasCalls">
              <ng-container *ngTemplateOutlet="positions; context: {$implicit: {side: 'Call'}}"></ng-container>
            </ng-container>

            <ng-container *ngIf="this.hasPuts">
              <hr style="border: 3px solid dimgray; width: 85%; margin-top: 20px; margin-bottom: 20px;">
              <ng-container *ngTemplateOutlet="positions; context: {$implicit: {side: 'Put'}}"></ng-container>
            </ng-container>
          </div>
        </dx-scroll-view>
      </div>

    </div>
  </div>

  <!--  Grand Totals Template -->
  <ng-template #grandTotalsTpl let-inline="inline">
    <div class="totals">
      <div [class.inline]="inline" class="call total">
        <div class="label">
          Calls Total
        </div>
        <div class="value">
          <div [style.display]="this.getGrandTotalsDisplay('Call', 'owned')"
               [style.visibility]="this.getGrandTotalsVisibility('Call', 'owned')"
               class="owned"
          >
            <dx-number-box
                #callTotalOwn
                [inputAttr]="this.getPriceBoxStyleInputAttr(callTotalOwn.value)"
                [readOnly]="true"
                [value]="this.getGrandTotalsValue('Call', 'owned')"
                format="$,##0.00"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getGrandTotalsDisplay('Call', 'trans')"
               [style.visibility]="this.getGrandTotalsVisibility('Call', 'trans')"
               class="trans"
          >
            <dx-number-box
                #callTotalTrans
                [inputAttr]="this.getPriceBoxStyleInputAttr(callTotalTrans.value)"
                [readOnly]="true"
                [value]="this.getGrandTotalsValue('Call', 'trans')"
                format="$,##0.00"
            ></dx-number-box>
          </div>
        </div>
      </div>

      <div [class.inline]="inline" class="put total">
        <div class="label">
          Puts Total
        </div>
        <div class="value">
          <div [style.display]="this.getGrandTotalsDisplay('Put', 'owned')"
               [style.visibility]="this.getGrandTotalsVisibility('Put', 'owned')"
               class="owned"
          >
            <dx-number-box
                #putTotalOwn
                [inputAttr]="this.getPriceBoxStyleInputAttr(putTotalOwn.value)"
                [readOnly]="true"
                [value]="this.getGrandTotalsValue('Put', 'owned')"
                format="$,##0.00"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getGrandTotalsDisplay('Put', 'trans')"
               [style.visibility]="this.getGrandTotalsVisibility('Put', 'trans')"
               class="trans"
          >
            <dx-number-box
                #putTotalTrans
                [inputAttr]="this.getPriceBoxStyleInputAttr(putTotalTrans.value)"
                [readOnly]="true"
                [value]="this.getGrandTotalsValue('Put', 'trans')"
                format="$,##0.00"
            ></dx-number-box>
          </div>

        </div>
      </div>

      <div [class.inline]="inline" class="all total">
        <div class="label">
          Grand Total
        </div>
        <div class="value">
          <div [style.display]="this.getGrandTotalsDisplay('Grand', 'owned')"
               [style.visibility]="this.getGrandTotalsVisibility('Grand', 'owned')"
               class="owned"
          >
            <dx-number-box
                #grandTotalOwn
                [inputAttr]="this.getPriceBoxStyleInputAttr(grandTotalOwn.value)"
                [readOnly]="true"
                [value]="this.getGrandTotal(callTotalOwn?.value, putTotalOwn?.value)"
                format="$,##0.00"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getGrandTotalsDisplay('Grand', 'trans')"
               [style.visibility]="this.getGrandTotalsVisibility('Grand', 'trans')"
               class="trans"
          >
            <dx-number-box
                #grandTotalTrans
                [inputAttr]="this.getPriceBoxStyleInputAttr(grandTotalTrans.value)"
                [readOnly]="true"
                [value]="this.getGrandTotal(callTotalTrans?.value, putTotalTrans?.value)"
                format="$,##0.00"
            ></dx-number-box>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!--  Short Version -->
  <div [style.display]="this.isShortVersion ? 'block' : 'none'" [style.height.%]="99">
    <div class="btn-review-changes-short">
      <ng-container *ngTemplateOutlet="reviewChangesBtn"></ng-container>
    </div>

    <ng-container *ngTemplateOutlet="grandTotalsTpl"></ng-container>

    <hr class="totals-separator">

    <div class="short-version">
      <dx-scroll-view>
        <div style="padding-bottom: 5px; height: 99%">
          <ng-container *ngIf="this.hasCalls">
            <ng-container *ngTemplateOutlet="shortVersion; context: {$implicit: {side: 'Call'}}"></ng-container>
          </ng-container>

          <ng-container *ngIf="this.hasPuts">
            <hr style="border-color: gray; width: 85%; margin-top: 10px; margin-bottom: 10px;">
            <ng-container *ngTemplateOutlet="shortVersion; context: {$implicit: {side: 'Put'}}"></ng-container>
          </ng-container>
        </div>
      </dx-scroll-view>
    </div>

  </div>
</div>

<!--Full Version Template-->
<ng-template #positions let-ctx>

  <div *ngFor="let pGroup of this.getLegGroups(ctx.side); first as isFirst; last as isLast"
       [class.different]="this.doesGroupHaveAnyChanges(pGroup)"
       class="positions-group"
  >
    <div class="group-common">
      <div class="common-attr reset">
        <dx-button (onClick)="this.resetGroup(pGroup)"
                   [disabled]="!this.canRevertGroup(pGroup) || this.isHedgeExpired(pGroup)"
                   icon="revert"
                   text="Reset"

        ></dx-button>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="common-attr hedge-color">
        <div>Color</div>
        <div [style.width.px]="50">
          <ets-color-picker
            (onValueChanged)="this.onHedgeColorChanged($event, pGroup)"
            [(selectedColor)]="pGroup.groupColor"
            [disabled]="this.isHedgeExpired(pGroup)"
            [removeColors]="this.usedColors"
            [showCallPalette]="ctx.side === 'Call'"
            [showPutPalette]="ctx.side === 'Put'"
          ></ets-color-picker>
        </div>
      </div>

      <div *ngIf="pGroup.underlying && this.esHedgingEnabled" [class.removed]="this.isGroupRemoved(pGroup)" class="common-attr hedge-underlying">
        <span class="underlying-badge">{{ pGroup.underlyingDisplayName }}</span>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="common-attr hedge-label">
        <div>Label</div>
        <div>
          <dx-text-box
            (onValueChanged)="this.onLabelChanged(pGroup, $event)"
            [(value)]="pGroup.groupLabel"
            [disabled]="this.isHedgeExpired(pGroup)"
            [inputAttr]="this.getLabelInputAttr(pGroup)"
          ></dx-text-box>
        </div>
      </div>

      <div #btnMerge [class.removed]="this.isGroupRemoved(pGroup)" class="common-attr merge">
        <dx-button
          (onClick)="this.showMergeDialog(ctx.side,pGroup, btnMerge)"
          [disabled]="!this.canMerge() || this.isHedgeExpired(pGroup)"
          text="Merge"
        ></dx-button>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="common-attr harvest">
        <dx-button
          (onClick)="this.onHarvestClicked(ctx.side,pGroup, btnMerge)"
          [disabled]="this.isHedgeExpired(pGroup)"
          text="Harvest"
        ></dx-button>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="common-attr copy">
        <dx-button
          (onClick)="this.copyHedgeBoxLegs(pGroup)"
          [disabled]="this.isHedgeExpired(pGroup)"
          icon="copy"
          hint="Copy legs (transaction if modified, otherwise - original)"
        ></dx-button>
      </div>

    </div>

    <div *ngFor="let leg of pGroup.legs" class="leg">

      <ng-container>
        <div
          [class.removed]="leg.removed"
          [style.visibility]="(pGroup.selectedForMerge && !leg.removed) ? 'visible' : 'hidden'"
          class="column duplicate"
        >
          <dx-check-box
            (onValueChanged)="this.onSelectedForMergeChanged(leg)"
            [(value)]="leg.selectedForMerge">
          </dx-check-box>
        </div>
        <div
          [class.active]="pGroup.selectedForHarvest"
          [class.removed]="leg.removed"
          [style.visibility]="(pGroup.selectedForHarvest && !leg.removed) ? 'visible' : 'hidden'"
          class="column duplicate jump"
          #harvestLeg
        >
          <dx-check-box
            (onValueChanged)="this.onSelectedForHarvestChanged(leg, pGroup)"
            [(value)]="leg.selectedForHarvest">
          </dx-check-box>

          <dx-popover
            [position]="'left'"
            [target]="harvestLeg"
            [visible]="this.isHarvestMeButtonVisible(leg, pGroup)"
          >
            <div *dxTemplate="let data of 'content'">
              <dx-button text="Harvest Me" (onClick)="this.onHarvestMeClicked(pGroup)"></dx-button>
            </div>
          </dx-popover>

        </div>
      </ng-container>

      <div [class.removed]="leg.removed" class="column buy-sell">
        <dx-select-box
          (onValueChanged)="this.onLegSideChanged(leg)"
          (valueChange)="this.onLegSideChanging(leg, $event)"
          [(value)]="leg.side"
          [disabled]="this.isMergeMode|| this.isLegExpired(leg)"
          [inputAttr]="{style: leg.sideStyle}"
          [items]="['Buy', 'Sell']"
          placeholder="Buy/Sell"
        >
          <div *dxTemplate="let data of 'item'">
            <span [style.color]="data === 'Buy' ? 'cornflowerblue' : 'red'">{{ data }}</span>
          </div>
        </dx-select-box>
      </div>

      <div [class.removed]="leg.removed" class="column qty">
        <div class="owned">
          <dx-number-box
            (onFocusIn)="this.onQtyFocusIn(leg)"
            (onValueChanged)="this.onChange()"
            (valueChange)="this.onLegQtyChange(leg, $event)"
            [disabled]="(this.isMergeMode && !leg.selectedForMerge) || this.isLegExpired(leg)"
            [inputAttr]="this.dxCenterTextStyleObj"
            [min]="1"
            [readOnly]="leg.selectedForTrans"
            [showSpinButtons]="false"
            [useLargeSpinButtons]="false"
            [value]="leg.absQty"
            placeholder="Qty"
          ></dx-number-box>
        </div>
        <div *ngIf="leg.selectedForTrans" class="split">
          <dx-number-box
              #transQtyBox
              (onFocusOut)="this.onQtyFocusOut(leg)"
              (onInitialized)="this.onQtyBoxInit(transQtyBox)"
              [(value)]="leg.transQty"
              [inputAttr]="this.dxCenterTextStyleObj"
              [min]="0"
          ></dx-number-box>
        </div>
      </div>

      <div [class.removed]="leg.removed" class="column expiration">
        <ng-container *ngIf="this.isLegExpired(leg)">
          <dx-text-box
            [disabled]="true"
            [readOnly]="true"
            [value]="this.getExpiredLegExpirationText(leg)"
            width="100%"
            [inputAttr]="this.dxCenterTextStyleObj"
          ></dx-text-box>
        </ng-container>
        <ng-container *ngIf="!this.isLegExpired(leg) && !this.isLegSeriesReady(leg)">
          <dx-text-box [readOnly]="true" [disabled]="true"
                       [value]="this.getLegSeriesDateText(leg)"
                       [inputAttr]="this.dxCenterTextStyleObj"></dx-text-box>
        </ng-container>
        <ng-container *ngIf="!this.isLegExpired(leg) && this.isLegSeriesReady(leg)">

          <ets-expiration-selector
            (expirationChanged)="this.onLegExpirationChanged(pGroup, leg, $event)"
            [selectedExpiration]="leg.expirationDescriptor"
            [disabled]="this.isMergeMode || this.isLegExpired(leg)"
            [inputAttr]="leg.expirationStyle"
            [expirationDescriptors]="leg.expirationList"
            [showClearButton]="true"
          ></ets-expiration-selector>

<!--          <dx-select-box-->
<!--            (onValueChanged)="this.onLegExpirationChanged(pGroup, leg)"-->
<!--            (valueChange)="this.onLegExpirationChanging(leg, $event)"-->
<!--            [(value)]="leg.expirationDescriptor"-->
<!--            [disabled]="this.isMergeMode || this.isLegExpired(leg)"-->
<!--            [inputAttr]="leg.expirationStyle"-->
<!--            [items]="leg.expirationList"-->
<!--            [showClearButton]="true"-->
<!--            displayExpr="dateWithDaysToExpiration"-->
<!--          >-->
<!--            <div *dxTemplate="let data of 'item'">-->
<!--                <span [style.color]="(data?.expirationTicker === '@SPX' ? 'yellow' : '')">-->
<!--                   {{ data?.dateWithDaysToExpiration }}-->
<!--                </span>-->
<!--            </div>-->
<!--          </dx-select-box>-->
        </ng-container>
      </div>

      <div [class.removed]="leg.removed" class="column put-call">
        <dx-select-box
          (onValueChanged)="this.onChange()"
          [(value)]="leg.type"
          [disabled]="this.isMergeMode || this.isLegExpired(leg)"
          [items]="['Call', 'Put']"
          [readOnly]="true"
          placeholder="Call/Put"
          [inputAttr]="this.dxCenterTextStyleObj"
        ></dx-select-box>
      </div>

      <div [class.removed]="leg.removed" class="column strike">
        <ng-container *ngIf="this.isLegExpired(leg) || !this.isLegSeriesReady(leg)">
          <dx-number-box
            [disabled]="true"
            [readOnly]="true"
            [value]="leg.strike"
            [inputAttr]="this.dxCenterTextStyleObj"
          ></dx-number-box>
        </ng-container>
        <ng-container *ngIf="!this.isLegExpired(leg) && this.isLegSeriesReady(leg)">
          <ets-strikes-dropdown
            (strikeChange)="this.onLegStrikeChanging(leg, $event)"
            (strikeChanged)="this.onLegStrikeChanged(leg)"
            [(strike)]="leg.strike"
            [disable]="this.isMergeMode"
            [expiration]="leg.expirationDescriptor"
            [targetInstrument]="this.tradingInstrument"
            [inputAttr]="this.dxCenterTextStyleObj"
          ></ets-strikes-dropdown>
        </ng-container>
      </div>

      <div [class.removed]="leg.removed" class="column price">

        <ng-container *ngIf="this.isLegExpired(leg)">
          <dx-number-box #expiredPnl
                         width="100%"
                         [value]="leg.expirationPnl"
                         format="$,##0.00"
                         [inputAttr]="this.getPriceBoxStyleInputAttr(expiredPnl.value)"
          ></dx-number-box>
        </ng-container>

        <ng-container *ngIf="!this.isLegExpired(leg)">
          <div [style.display]="this.getOwnPriceboxDisplay()"
               [style.visibility]="this.getPriceboxVisibility(leg, 'owned')"
               class="owned"
          >
            <dx-number-box
                #pxOwn
                [readOnly]="true"
                [value]="this.getLegPrice(leg, 'owned')"
                format="$,##0.00"
                [inputAttr]="this.getPriceBoxStyleInputAttr(pxOwn.value)"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getTransPriceboxDisplay(ctx.side)"
               [style.visibility]="this.getPriceboxVisibility(leg, 'trans')"
               class="trans"
          >
            <dx-number-box
                #pxTrans
                [readOnly]="true"
                [value]="this.getLegPrice(leg, 'trans')"
                format="$,##0.00"
                [inputAttr]="this.getPriceBoxStyleInputAttr(pxTrans.value)"
            ></dx-number-box>
          </div>
        </ng-container>

      </div>

      <div [class.disabled]="this.isMergeMode || this.isHedgeFullyExpired(pGroup)" class="column remove">
        <i (click)="this.removeLeg(leg, ctx.side)" *ngIf="!leg.removed" class="fa fa-times-circle"></i>
        <i (click)="this.restoreLeg(leg)" *ngIf="leg.removed" class="fa fa-undo"></i>
      </div>

    </div>

    <!--    Totals Row -->
    <div class="leg total">

      <div [style.visibility]="'hidden'" class="column duplicate">
        <dx-check-box></dx-check-box>
      </div>

      <div class="column buy-sell">
        <div style="width: 100%; text-align: center">
          <dx-button
            (onClick)="this.addLeg(pGroup, ctx.side)"
            [disabled]="this.isMergeMode || this.isHedgeExpired(pGroup)"
            text="Add Option"
          ></dx-button>
        </div>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="column qty">
        <dx-number-box [style.visibility]="'hidden'"></dx-number-box>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="column expiration">
        <dx-check-box (onValueChanged)="this.onExpirationsLinkedChanged(pGroup)"
                      [(value)]="pGroup.expirationsLinked"
                      [disabled]="this.isHedgeExpired(pGroup)"
                      text="Linked">
        </dx-check-box>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="column put-call">
        <dx-select-box
          [style.visibility]="'hidden'"
        ></dx-select-box>
      </div>

      <div [class.removed]="this.isGroupRemoved(pGroup)" class="column strike">
        <ets-strikes-dropdown
          [style.visibility]="'hidden'"
        ></ets-strikes-dropdown>
      </div>

      <div class="column price">

        <ng-container *ngIf="this.isHedgeFullyExpired(pGroup)">
          <div class="owned">
            <dx-number-box #expiredTotal
                           [readOnly]="true"
                           [value]="this.getHedgeExpirationPnl(pGroup)"
                           format="$,##0.00"
                           [inputAttr]="this.getPriceBoxStyleInputAttr(expiredTotal.value)"
            ></dx-number-box>
          </div>
        </ng-container>

        <ng-container *ngIf="!this.isHedgeFullyExpired(pGroup)">

          <div [style.display]="this.getOwnPriceboxDisplay()"
               [style.visibility]="this.getPriceboxVisibility(pGroup, 'owned', ctx.side)"
               class="owned"
          >
            <dx-number-box
                #totalPxOwned
                [readOnly]="true"
                [value]="this.getGroupTotalPrice(pGroup, 'owned')"
                format="$,##0.00"
                [inputAttr]="this.getPriceBoxStyleInputAttr(totalPxOwned.value)"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getTransPriceboxDisplay(ctx.side)"
               [style.visibility]="this.getPriceboxVisibility(pGroup, 'trans', ctx.side)"
               class="trans"
          >
            <dx-number-box
                #totalPxTrans
                [readOnly]="true"
                [value]="this.getGroupTotalPrice(pGroup,'trans')"
                format="$,##0.00"
                [inputAttr]="this.getPriceBoxStyleInputAttr(totalPxTrans.value)"
            ></dx-number-box>
          </div>
        </ng-container>


      </div>

      <div [class.disabled]="this.isMergeMode || this.isHedgeFullyExpired(pGroup)" class="column remove total-x">
        <i (click)="this.removeWholeGroup(pGroup, ctx.side)" *ngIf="!this.isGroupRemoved(pGroup)"
           class="fa fa-times-circle"></i>
        <i (click)="this.restoreWholeGroup(pGroup)" *ngIf="this.isGroupRemoved(pGroup)" class="fa fa-undo"></i>
      </div>
    </div>

    <br *ngIf="!isLast">

  </div>

  <ets-hg-merge-dialog (packageSelected$)="this.onPackageSelectedForMerge($event)">
  </ets-hg-merge-dialog>

</ng-template>

<!--Short Version Template-->
<ng-template #shortVersion let-ctx>

  <div *ngFor="let pGroup of this.getLegGroups(ctx.side); first as isFirst; last as isLast"
       [class.different]="this.doesGroupHaveAnyChanges(pGroup)"
       class="positions-group"
  >
    <div [class.removed]="this.isGroupRemoved(pGroup)" [style.color]="pGroup.groupColor"
         class="group-label"
    >
      <span *ngIf="pGroup.underlying && this.esHedgingEnabled" class="underlying-badge short">{{ pGroup.underlyingDisplayName }}</span>
      <span>{{ pGroup.groupLabel }}</span>
    </div>

    <div *ngFor="let leg of pGroup.legs" class="leg">

      <div [class.removed]="leg.removed" [style.color]="pGroup.groupColor" class="column buy-sell">
        <dx-text-box
          [disabled]="this.isLegExpired(leg)"
          [readOnly]="true"
          [value]="leg.side"
          [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
        ></dx-text-box>
      </div>

      <div [class.removed]="leg.removed" [style.color]="pGroup.groupColor" class="column qty">
        <div class="owned">
          <dx-number-box
            [disabled]="this.isLegExpired(leg)"
            [readOnly]="true"
            [value]="leg.qty"
            placeholder="Qty"
            [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
          ></dx-number-box>
        </div>
        <div *ngIf="leg.selectedForTrans" class="split">
          <dx-number-box
            [disabled]="this.isLegExpired(leg)"
            [readOnly]="true"
            [value]="leg.transQty * (leg.side === 'Buy' ? 1 : -1)"
            [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
          ></dx-number-box>
        </div>
      </div>

      <div [class.removed]="leg.removed" [style.color]="pGroup.groupColor" class="column expiration">
        <ng-container *ngIf="this.isLegExpired(leg)">
          <dx-text-box [disabled]="true"
                       [readOnly]="true"
                       [value]="this.getExpiredLegExpirationText(leg)"
                       [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
          ></dx-text-box>
        </ng-container>
        <ng-container *ngIf="!this.isLegExpired(leg)">
          <dx-text-box
            [readOnly]="true"
            [value]="leg.expirationDescriptor?.dateWithDaysToExpiration"
            [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
          ></dx-text-box>
        </ng-container>
      </div>

      <div [class.removed]="leg.removed" [style.color]="pGroup.groupColor" class="column put-call">
        <dx-text-box
          [disabled]="this.isLegExpired(leg)"
          [readOnly]="true"
          [value]="leg.type"
          [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
        ></dx-text-box>
      </div>

      <div [class.removed]="leg.removed" [style.color]="pGroup.groupColor" class="column strike">
        <dx-number-box
          [disabled]="this.isLegExpired(leg)"
          [readOnly]="true"
          [value]="leg.strike"
          [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
        ></dx-number-box>
      </div>

      <div [class.removed]="leg.removed" class="column price">

        <ng-container *ngIf="this.isLegExpired(leg)">
          <dx-number-box #expiredPnl
                         [value]="leg.expirationPnl"
                         [readOnly]="true"
                         format="$,##0.00"
                         width="100%"
                         [inputAttr]="this.getPriceBoxStyleInputAttr(expiredPnl.value)"
          ></dx-number-box>
        </ng-container>

        <ng-container *ngIf="!this.isLegExpired(leg)">
          <div [style.display]="this.getOwnPriceboxDisplay()"
               [style.visibility]="this.getPriceboxVisibility(leg, 'owned')"
               class="owned"
          >
            <dx-number-box
                #pxOwn
                [readOnly]="true"
                [value]="this.getLegPrice(leg, 'owned')"
                format="$,##0.00"
                [inputAttr]="{style: 'text-align: center; color: ' + this.getPnLColor(pxOwn.value)}"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getTransPriceboxDisplay(ctx.side)"
               [style.visibility]="this.getPriceboxVisibility(leg, 'trans')"
               class="trans"
          >
            <dx-number-box
                #pxTrans
                [readOnly]="true"
                [value]="this.getLegPrice(leg, 'trans')"
                format="$,##0.00"
                [inputAttr]="{style: 'text-align: center; color: ' + this.getPnLColor(pxTrans.value)}"
            ></dx-number-box>
          </div>
        </ng-container>

      </div>

    </div>

    <div class="total leg">

      <div class="column buy-sell">
        <span>&nbsp;</span>
      </div>

      <div class="column qty">
        <span>&nbsp;</span>
      </div>

      <div [style.color]="pGroup.groupColor" class="column expiration">
        <span>&nbsp;</span>
      </div>

      <div [style.color]="pGroup.groupColor" class="column put-call">
        <span>&nbsp;</span>
      </div>

      <div [style.color]="pGroup.groupColor" class="column strike">
        <span>&nbsp;</span>
      </div>

      <div class="column price">

        <ng-container *ngIf="this.isHedgeFullyExpired(pGroup)">
          <dx-number-box #expiredTotal
                         [readOnly]="true"
                         [value]="this.getHedgeExpirationPnl(pGroup)"
                         format="$,##0.00"
                         width="100%"
                         [inputAttr]="this.getPriceBoxStyleInputAttr(expiredTotal.value)"
          ></dx-number-box>
        </ng-container>

        <ng-container *ngIf="!this.isHedgeFullyExpired(pGroup)">
          <div [style.display]="this.getOwnPriceboxDisplay()"
               [style.visibility]="this.getPriceboxVisibility(pGroup, 'owned', ctx.side)"
               class="owned"
          >
            <dx-number-box
                #totalPxOwned
                [readOnly]="true"
                [value]="this.getGroupTotalPrice(pGroup, 'owned')"
                format="$,##0.00"
                [inputAttr]="this.getPriceBoxStyleInputAttr(totalPxOwned.value)"
            ></dx-number-box>
          </div>

          <div [style.display]="this.getTransPriceboxDisplay(ctx.side)"
               [style.visibility]="this.getPriceboxVisibility(pGroup, 'trans', ctx.side)"
               class="trans"
          >
            <dx-number-box
                #totalPxTrans
                [readOnly]="true"
                [value]="this.getGroupTotalPrice(pGroup,'trans')"
                format="$,##0.00"
                [inputAttr]="this.getPriceBoxStyleInputAttr(totalPxTrans.value)"
            ></dx-number-box>
          </div>
        </ng-container>


      </div>

    </div>

  </div>
</ng-template>

<ets-generic-confirmation-dialog title="Please Confirm Action">
</ets-generic-confirmation-dialog>

<ets-hedges-sorting-dialog></ets-hedges-sorting-dialog>

<ets-orders-chain-dialog></ets-orders-chain-dialog>
